class Colors {
  black: string = "#25272B"
  white: string = "#FFFFFF"
  beige: string = "#F3F3EE"
  gray: string = "#75787B"
  lightGray: string = "#E6E5EA"
  lightestGray: string = "#ffffffe5"
  bluishGray: string = "#C4CEE3"
  borderGray: string = "#C9CAD6"
  blue: string = "#395AA1"
  darkBlue: string = "#141B4D"
  lightBlue: string = "#87B0D6"
  purplishBlue: string = "#393daf"
  turquoise: string = "#00A7B5"
  lightTurquoise: string = "#B3E5E9"
  red: string = "#BA0C2F"
  lighterRed: string = "#B52555"
  lightRed: string = "#EBB7C1"
  darkOrange: string = "#DA291C"
  orange: string = "#ED7D25"
  lightOrange: string = "#F6BD90"
  lightPink: string = "#E9BECC"

  textToBg: Record<string, string> = {
    lighterRed: this.white,
    red: this.white,
    darkBlue: this.white,
    orange: this.white,
    turquoise: this.black,
  }

  dropShadow: Record<string, string> = {
    main: "8px 8px 30px #02275729",
    mainSmall: "-8px 8px 30px #0F244F1F",
    light: "0px 0px 9px rgba(0, 0, 0, 0.06)",
    header: "0px 4px 16px #5A5A5A0D",
  }

  colorToArrowNoLinesIcons: Record<string, string> = {
    turquoise: "arrow_lightTurquoise_black",
    red: "arrow_lightRed_black",
    orange: "arrow_lightOrange_black",
    blue: "arrow_lightBlue_black",
    darkBlue: "arrow_bluishGray_black",
    black: "arrow_gray_black",
    darkOrange: "arrow_lightRed_black",
  }

  colorToArrowBlackLinesIcons: Record<string, string> = {
    pink: "arrow_lightPink_black_line",
    red: "arrow_orange_black_line",
    blue: "arrow_bluishGray_black_line",
    orange: "arrow_lightOrange_black_line",
    turquoise: "arrow_lightTurquoise_black_line",
    darkBlue: "arrow_bluishGray_black_line",
    darkOrange: "arrow_lightOrange_black_line",
  }

  colorToCheckIcons: Record<string, string> = {
    lightTurquoise: "check_turquoise_black_line",
    lightOrange: "check_orange_black_line",
    lightRed: "check_red_black_line",
    pink: "check_pink_black_line",
  }

  // Helper to resolve color names dynamically
  resolveColorName(hexCode: string): string | undefined {
    // Get all properties of the Colors class

    const colorKeys = Object.keys(this).filter(
      (key) => typeof (this as any)[key] === "string",
    )
    return colorKeys.find(
      (colorKey) => (this as any)[colorKey] === hexCode.toUpperCase(),
    )
  }

  // Helper to generate icon key dynamically
  getArrowIconNoLinesKey(hexCode: string): string | undefined {
    const colorName = this.resolveColorName(hexCode)

    if (!colorName) {
      console.warn(`No matching color name found for hex code: ${hexCode}`)
      return undefined
    }
    return this.colorToArrowNoLinesIcons[colorName]
  }

  getArrowIconBlackLinesKey(hexCode: string): string | undefined {
    const colorName = this.resolveColorName(hexCode)

    if (!colorName) {
      console.warn(`No matching color name found for hex code: ${hexCode}`)
      return undefined
    }
    return this.colorToArrowBlackLinesIcons[colorName]
  }

  getCheckIconKey(hexCode: string): string | undefined {
    const colorName = this.resolveColorName(hexCode)
    if (!colorName) {
      console.warn(`No matching color name found for hex code: ${hexCode}`)
      return undefined
    }
    return this.colorToCheckIcons[colorName]
  }
}

export const colors = new Colors()
